import { useSelector } from 'react-redux';

export const signInResultSelector = state => state.auth.signInResult;
export const useLoginData = () => useSelector(state => state.auth.loginData);
